<template>
  <div>
    <MPHeader class="headerContainer" :showSlider="false"></MPHeader>
    <ImageSlider v-if="showSlider"></ImageSlider>
    <div style="float:right;margin:10px">
      <FITButton v-if="isShopOwner " class="productBtn " :iconOnly="true" faIcon="fa-share-square" variant="outline-danger" @click="openDialog" v-clipboard="copyData" @success="copySuccess" @error="copyError"></FITButton>
    </div>
    <div v-transfer-dom>
                <x-dialog v-model="show" class="dialog-demo">
                  <social-sharing :url="copyData"
                      :title="$t('kol.footer.shop')+'-'+$t('account.credit.title')"
                      description="KOL platform"
                      :quote="$t('kol.footer.shop')+'-'+$t('account.credit.title')"
                      hashtags=""
                      twitter-user=""
                      inline-template>
                      <div>
                      <network network="facebook">
                        <i class="fab fa-facebook-f"></i> Facebook
                      </network>
                      </div>
                  </social-sharing>
                  <div style="margin:5px">
                  <a :href="whatsappShareText" target="_blank"><i class="fab fa-whatsapp"></i> Whatsapp</a>
                  </div>
                    <FITButton v-if="isShopOwner " style="margin:0px !important" :size="'md'" class="productBtn " :iconOnly="true" faIcon="fa-share" variant="link" @click="shareCurrentPage" v-clipboard="copyData" @success="copySuccess" @error="copyError" :text="'share'"></FITButton>
                  <div @click="show=false">
                    <span class="vux-close">Close</span>
                  </div>
                </x-dialog>
      </div>
    <div v-transfer-dom>
      <alert :button-text="alertBtnText" v-model="showAlert">{{alertMsg}}</alert>
    </div>
    
    <GridContainer VuexModule="Shop" class="my-2" :shopProductList="true" :title="$t('product.list.containerTitle.myProduct')"></GridContainer>
  </div>
</template>
<script type="text/javascript">
import {FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton, MPHeader, MPFooter } from '@/components' 
import { mapGetters } from 'vuex'
import GridContainer from '@/Product/components/GridContainer'
import Cookies from 'js-cookie'
import { TransferDom, Alert, Confirm, XDialog, XButton } from 'vux'
import ImageSlider from '../../components/Header/ImageSlider'

export default {
  name: 'KOLShop',
  directives: {
    TransferDom
  },
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    MPHeader,
    MPFooter,
    GridContainer,
    Alert,
    Confirm,
    XDialog,
    ImageSlider,
    XButton
  },
  props: {
    showSlider:{
      type:Boolean,
      default:true,
    }
  },
  data() {
    return {
      show:false,
      showAlert: false,
      alertMsg: '',
      alertBtnText: this.$t('kol.header.confirm'),
    }
  },
  created() {
    document.title = `${this.$t('kol.footer.shop')} - ${this.$t('kol.title')}`;
    if(Cookies.get('redirect') == "true"){
      return
    }else{
      Cookies.set('redirect',false);
    }
    this.getUserDetail();
  },
  mounted() {},
  watch: {},
  computed: {
    isShopOwner() {
      let result = false;
      let role = this.currentRole;
      let currentShopLink = this.$router.currentRoute.query.link;
      let cookieShopLink = Cookies.get('shopLink');

      if(role == "K" || role == 'R'){
          result = true;
      }
      if(currentShopLink){
        if(currentShopLink == cookieShopLink){
          return true;
        }
      }
      return result;
    },
    currentRole() {
      return Cookies.get('role');
    },
    copyData() {
      let string = document.title + '\n\n';
      let copyData = "";
      console.log(this.$router.currentRoute)
      //live server
      copyData = 'https://mobile.kolpartner.com/ProcessPage.php?link=' + this.$router.currentRoute.query.link;
      //test server
      // copyData = 'https://test.ftech.com.hk/kol-h5/ProcessPage.php?link=' + this.$router.currentRoute.query.link;
      
      // let copyData = 'https://mobile.kolpartner.com' + this.$router.currentRoute.fullPath;
      // string += copyData;
      // console.log(string);
      return copyData;
    },
    whatsappShareText(){
      var link = 'https://api.whatsapp.com/send?text='+ encodeURIComponent(this.copyData)
      return link
    },
  },
  methods: {
    openDialog(){
      this.show = true;
    },
    copySuccess(e) {
      console.log('Success: ' + e);
    },
    copyError(e) {
      console.log('Error: ' + e);
    },
    shareCurrentPage() {
      this.alertBtnText = this.$t('shop.detail.shareConfirmText');
      this.alertMsg = this.$t('shop.detail.shareBodyText');
      this.showAlert = true;
      this.show = false;
    },
    getUserDetail() {

      this.$store.dispatch('Account/getUserDetail', {}).then((json) => {

        if (json.status == 401) {
          Cookies.remove('token');
          this.$router.push('/login');
        } else {
          var data = JSON.stringify(json.data)
          localStorage.setItem('currentUser',data);
          this.$store.commit("updateCurrentUser", json.data);
          this.currentUser = json.data
          // console.log(JSON.parse(localStorage.getItem('currentUser')));
          // console.log(json.data);
        }
      }).catch((err) => {
        console.error(err);
      });
    },
  },
}

</script>
<style type="text/css">
.headerContainer{
/*  margin-top: 44px;
*/}
</style>




// WEBPACK FOOTER //
// src/Shop/containers/KOLShop.vue